import { useTranslation } from '../i18n/LanguageContext.jsx';
import './AgentDescription.css';

/**
 * AgentDescription component — detailed bilingual explanation of the
 * interview agent POC architecture, including multi-agent system,
 * tools, guardrails, and how the chatbot works.
 */
function AgentDescription() {
  const { t } = useTranslation();

  return (
    <div className="agent-description">
      <h2 className="agent-description__title">{t('interview.agentDescriptionTitle')}</h2>
      <p className="agent-description__intro">{t('interview.agentDescription')}</p>

      <div className="agent-description__details">
        <h3 className="agent-description__subtitle">{t('interview.howItWorksTitle')}</h3>

        <div className="agent-description__architecture">
          <div className="agent-description__card">
            <div className="agent-description__card-icon" aria-hidden="true">
              🛡️
            </div>
            <h4>{t('interview.guardrailTitle')}</h4>
            <p>{t('interview.guardrailDesc')}</p>
          </div>

          <div className="agent-description__card">
            <div className="agent-description__card-icon" aria-hidden="true">
              🤖
            </div>
            <h4>{t('interview.orchestratorTitle')}</h4>
            <p>{t('interview.orchestratorDesc')}</p>
          </div>

          <div className="agent-description__card">
            <div className="agent-description__card-icon" aria-hidden="true">
              📄
            </div>
            <h4>{t('interview.cvLookupTitle')}</h4>
            <p>{t('interview.cvLookupDesc')}</p>
          </div>

          <div className="agent-description__card">
            <div className="agent-description__card-icon" aria-hidden="true">
              🔍
            </div>
            <h4>{t('interview.webResearchTitle')}</h4>
            <p>{t('interview.webResearchDesc')}</p>
          </div>
        </div>

        <p className="agent-description__note">{t('interview.architectureNote')}</p>

        <div className="agent-description__highlights">
          <h3 className="agent-description__highlights-title">
            {t('interview.techHighlightsTitle')}
          </h3>
          <div className="agent-description__highlights-grid">
            <div className="agent-description__highlight">
              <div className="agent-description__highlight-icon" aria-hidden="true">
                🧠
              </div>
              <div className="agent-description__highlight-content">
                <strong>{t('interview.highlightMultiAgentTitle')}</strong>
                <span>{t('interview.highlightMultiAgentDesc')}</span>
              </div>
            </div>
            <div className="agent-description__highlight">
              <div className="agent-description__highlight-icon" aria-hidden="true">
                ⚡
              </div>
              <div className="agent-description__highlight-content">
                <strong>{t('interview.highlightStreamingTitle')}</strong>
                <span>{t('interview.highlightStreamingDesc')}</span>
              </div>
            </div>
            <div className="agent-description__highlight">
              <div className="agent-description__highlight-icon" aria-hidden="true">
                🔒
              </div>
              <div className="agent-description__highlight-content">
                <strong>{t('interview.highlightProductionTitle')}</strong>
                <span>{t('interview.highlightProductionDesc')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgentDescription;
